<template>
  <div class="sales-page">
    <div class="header-bar">
      <h2>销售流水</h2>
      <p>查看每一笔收益</p>
    </div>

    <div class="income-cards">
      <div class="income-item">
        <div class="income-label">累计收入</div>
        <div class="income-value">¥{{ formatNum(totalIncome) }}</div>
      </div>
      <div class="income-divider" />
      <div class="income-item">
        <div class="income-label">可提现余额</div>
        <div class="income-value highlight">¥{{ formatNum(withdrawable) }}</div>
      </div>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="— 没有更多了 —"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.id" class="order-card">
        <div class="order-left">
          <div class="order-icon">
            <van-icon name="balance-o" size="20" color="#6366f1" />
          </div>
          <div class="order-info">
            <div class="order-title">{{ item.resourceTitle }}</div>
            <div class="order-meta">
              <span>买家 {{ item.buyerName }}</span>
              <span class="meta-dot">·</span>
              <span>{{ formatDate(item.paidAt) }}</span>
            </div>
          </div>
        </div>
        <div class="order-right">
          <div class="order-amount">¥{{ item.actualAmount || item.amount }}</div>
          <div class="order-income">+¥{{ item.bloggerIncome }}</div>
        </div>
      </div>
    </van-list>

    <van-empty
      v-if="!loading && list.length === 0"
      image="search"
      description="还没有销售记录"
    />
  </div>
</template>

<script>
import { orderApi, bloggerApi } from '../api';

export default {
  data() {
    return {
      list: [], page: 1, size: 10, loading: false, finished: false,
      totalIncome: 0, withdrawable: 0
    };
  },
  created() { this.fetchProfile(); },
  methods: {
    async fetchProfile() {
      try {
        const res = await bloggerApi.getProfile();
        this.totalIncome = res.data.totalIncome;
        this.withdrawable = res.data.withdrawable;
      } catch (e) { /* ignore */ }
    },
    async onLoad() {
      const res = await orderApi.getTransactions({ page: this.page, size: this.size });
      const data = res.data;
      this.list = this.page === 1 ? data.list : [...this.list, ...data.list];
      this.loading = false;
      if (this.list.length >= data.total) this.finished = true;
      this.page++;
    },
    formatNum(n) {
      return (parseFloat(n) || 0).toFixed(2);
    },
    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    }
  }
};
</script>

<style scoped>
.sales-page { min-height: 100vh; background: #f5f7fa; }
.header-bar {
  padding: 20px 20px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
}
.header-bar h2 {
  margin: 0; font-size: 22px; font-weight: 700;
}
.header-bar p {
  margin: 2px 0 0; font-size: 13px; opacity: 0.8;
}
.income-cards {
  display: flex; margin: -16px 16px 16px;
  background: #fff; border-radius: 12px;
  padding: 16px 0; box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  position: relative; z-index: 1;
}
.income-item {
  flex: 1; text-align: center;
}
.income-label {
  font-size: 12px; color: #9ca3af; margin-bottom: 4px;
}
.income-value {
  font-size: 20px; font-weight: 700; color: #1f2937;
}
.income-value.highlight { color: #ef4444; }
.income-divider {
  width: 1px; background: #e5e7eb; align-self: stretch;
}
.order-card {
  display: flex; align-items: center; justify-content: space-between;
  margin: 8px 16px; padding: 14px; background: #fff;
  border-radius: 10px; box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.order-left { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0; }
.order-icon {
  width: 40px; height: 40px; border-radius: 10px;
  background: #eef2ff; display: flex;
  align-items: center; justify-content: center; flex-shrink: 0;
}
.order-info { min-width: 0; }
.order-title {
  font-size: 14px; font-weight: 600; color: #1f2937;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.order-meta {
  font-size: 12px; color: #9ca3af; margin-top: 2px;
}
.meta-dot { margin: 0 4px; }
.order-right { text-align: right; flex-shrink: 0; margin-left: 12px; }
.order-amount { font-size: 15px; font-weight: 600; color: #1f2937; }
.order-income {
  font-size: 12px; color: #22c55e; font-weight: 500;
  margin-top: 2px;
}
</style>
